import { render, staticRenderFns } from "./wuliaoList.vue?vue&type=template&id=eb123f5a&scoped=true&"
import script from "./wuliaoList.vue?vue&type=script&lang=js&"
export * from "./wuliaoList.vue?vue&type=script&lang=js&"
import style0 from "./wuliaoList.vue?vue&type=style&index=0&id=eb123f5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb123f5a",
  null
  
)

export default component.exports